import { store } from 'store.js';
import axios from 'axios';
import { aggiornaScadenze, caricamento, aggiornaClienti, aggiornaClientiConCodice } from 'features/98/scadenze/scadenzeSlice';
import { aggiornaCurrentCliente } from 'features/global/globalSlice';
import { API_URL } from 'config.js';

const API_SCADENZE_URL = `${API_URL}/98/get_scadenze/`;
const API_AGING_URL = `${API_URL}/98/get_aging/`;
const API_FILE_URL = `${API_URL}/generals/get_file/`;

export const getDocName = (documento, anno) => {
  const codice = documento.substring(0, 2); // es. BC
  const serie = `0${documento.charAt(2)}`; // es. 01
  const numero = `000000${documento.split('/')[1]}`.slice(-6); // es. 002699

  return `${anno}-${codice}-${serie}-${numero}`;
};

const b64toBlob = (b64Data, contentType = 'application/pdf', sliceSize = 512) => {
  const byteCharacters = atob(b64Data);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);

    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i += 1) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  const blob = new Blob(byteArrays, { type: contentType });
  return blob;
};

export async function richiediDati() {
  store.dispatch(caricamento(true));

  const {
    auth: {
      currentUser: { pin, utente },
    },
  } = store.getState();

  const res = await axios.post(API_SCADENZE_URL, { utente, pin });

  const {
    data: { successo, scadenze = [], clienti = [], clientiConCodice = [] },
  } = res;

  if (successo) {
    store.dispatch(aggiornaScadenze(scadenze ?? []));
    store.dispatch(aggiornaClienti(clienti ?? []));
    store.dispatch(aggiornaClientiConCodice(clientiConCodice ?? []));
    store.dispatch(aggiornaCurrentCliente(clienti[0] ?? []));
  } else {
    store.dispatch(aggiornaScadenze([]));
  }

  store.dispatch(caricamento(false));
}

export async function richiediAging(cliente) {
  console.info('AGINGGGG');
  try {
    const {
      auth: {
        currentUser: { pin, utente },
      },
      scadenze98: { clientiConCodice },
    } = store.getState();

    const codCliente = clientiConCodice?.find((a) => a.Cliente === cliente)?.CodCliente;
    if (!codCliente) return [];
    const res = await axios.post(API_AGING_URL, { utente, pin, cliente: codCliente });
    return res.data;
  } catch {
    // eslint-disable-next-line no-alert
    alert('Error while retrieving data, code: v-98-s-f-76');
    return { error: true };
  }
}

export const getFile = async (documento, anno) => {
  const {
    auth: {
      currentUser: { pin, utente },
    },
  } = store.getState();
  store.dispatch(caricamento(true));
  const res = await axios.post(API_FILE_URL, { utente, pin, idContratto: 0, documento: getDocName(documento, anno) });
  store.dispatch(caricamento(false));
  const { successo } = res.data;

  if (!successo) {
    const { errore } = res.data;
    // eslint-disable-next-line no-alert
    alert(errore);
    return;
  }

  const { file } = res.data; // YEY abbiamo il nostro file base64
  const fileBlob = b64toBlob(file);
  const fileUrl = URL.createObjectURL(fileBlob);

  window.open(fileUrl, '_blank');
};
